import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const mics = [
  {
    name: 'Poly Voyager 4310 UC',
    manufacturer: 'Poly (HP)',
    formFactor: 'Wireless headset',
    connection: 'USB wireless adapter'
  },
  {
    name: 'Hollyland Lark M2',
    manufacturer: 'Hollyland',
    formFactor: 'Clip-on lavalier',
    connection: 'USB-C receiver or Bluetooth'
  },
  {
    name: 'Jiamqishi EH02U',
    manufacturer: 'Jiamqishi',
    formFactor: 'Wireless headset',
    connection: 'USB wireless adapter'
  },
  {
    name: 'EMEET Luna',
    manufacturer: 'EMEET',
    formFactor: 'Conference speakerphone',
    connection: 'USB wireless'
  },
  {
    name: 'Philips SmartMike Duo',
    manufacturer: 'Philips',
    formFactor: 'Desktop conference mic',
    connection: 'Wired'
  }
];

const RecommendedMicsPage = () => {
  return (
    <div className="min-h-screen bg-white selection:bg-blue-100 selection:text-blue-900">
      <Header />

      <main className="pt-32 pb-24 px-4">
        <div className="container mx-auto max-w-3xl">
          <h1 className="text-3xl md:text-4xl font-bold mb-4 leading-tight text-slate-900 tracking-tight">
            Recommended Microphones
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed mb-10">
            Asha's voice perio charting and AI scribe work with any microphone that connects to your
            computer — including any Bluetooth mic you already own. If you're shopping for one, here
            are some options we recommend.
          </p>

          <div className="border border-slate-200 rounded-xl overflow-hidden shadow-sm">
            <table className="w-full text-left text-sm">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-200">
                  <th className="px-5 py-3 font-semibold text-slate-700">Microphone</th>
                  <th className="px-5 py-3 font-semibold text-slate-700">Manufacturer</th>
                  <th className="px-5 py-3 font-semibold text-slate-700">Type</th>
                  <th className="px-5 py-3 font-semibold text-slate-700">Connection</th>
                </tr>
              </thead>
              <tbody>
                {mics.map((mic, index) => (
                  <tr key={index} className="border-b border-slate-100 last:border-b-0">
                    <td className="px-5 py-3.5 font-medium text-slate-900">{mic.name}</td>
                    <td className="px-5 py-3.5 text-slate-600">{mic.manufacturer}</td>
                    <td className="px-5 py-3.5 text-slate-600">{mic.formFactor}</td>
                    <td className="px-5 py-3.5 text-slate-600">{mic.connection}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RecommendedMicsPage;
